<template>
  <div class="message">
    <div class="message-left" @click="handlePrev"></div>
    <div class="message-center">
      <div class="message-center-left">
        <img :src="LOVE" />
        <div>我们的客户</div>
      </div>
      <div class="message-center-right">
        <img :src="list[index] ? ('http://tarzan.minus.live' + list[index].img) : ''" />
      </div>
    </div>
    <div class="message-right" @click="handleNext"></div>
  </div>
</template>

<script>
import LOVE from '../assets/images/message/love.png'
import ICON_MESSAGE from '../assets/images/message/icon-message.png'
import USER from '../assets/images/message/user.png'
import { getCaseList } from '../services'

export default {
  data () {
    return {
      LOVE,
      ICON_MESSAGE,
      USER,
      index: 0,
      list: []
    }
  },
  created () {
    getCaseList().then(res => {
      this.list = res.data.data.data.children
    })
  },

  methods: {
    handleNext () {
      if (this.index < this.list.length - 1) {
        this.index += 1
      }
    },

    handlePrev () {
      if (this.index > 0) {
        this.index -= 1
      }
    }
  }
}
</script>

<style lang="less" scoped>
.message {
  background: url('../assets/images/message/bg.png');
  max-width: 100%;
  height: 300px;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  

  @media (min-width: 1280px) and (max-width: 1680px){
    height: 450px;
  }
        
  @media screen and (min-width: 1920px){
    height: 600px;
  }

  &-left {
    width: 30px;
    height: 30px;
    background: url('../assets/images/message/icon-left.png');
    background-size: 100% 100%;

    @media (min-width: 1280px) and (max-width: 1680px){
      width: 45px;
      height: 45px;
    }
          
    @media screen and (min-width: 1920px){
      width: 60px;
      height: 60px;
    }
  }

  &-right {
    width: 30px;
    height: 30px;
    background: url('../assets/images/message/icon-right.png');
    background-size: 100% 100%;

    @media (min-width: 1280px) and (max-width: 1680px){
      width: 45px;
      height: 45px;
    }
          
    @media screen and (min-width: 1920px){
      width: 60px;
      height: 60px;
    }
  }

  &-center {
    display: flex;
    align-items: center;
    padding: 0 40px;
    &-left {
      color: #fff;
      padding: 0 60px 0 20px;
      div {
        width: 100px;
        font-size: 20px;
        text-align: left;

        @media (min-width: 1280px) and (max-width: 1680px){
          width: 150px;
          font-size: 30px;
        }
              
        @media screen and (min-width: 1920px){
          width: 200px;
          font-size: 40px;
        }
      }
    }

    &-right {
      width: 375px;
      height: 209px;
      background: #fff;
      border: 1px dashed #515151;
      position: relative;

      @media (min-width: 1280px) and (max-width: 1680px){
        width: 565px;
        height: 300px;
      }
            
      @media screen and (min-width: 1920px){
        width: 750px;
        height: 418px;
      }

      > img {
        width: 100%;
        height: 100%;
      }

      .msg {
        position: absolute;
        top: 80px;
        left: 20px;
        font-size: 9px;
        color: #515151;
        text-align: left;

        @media (min-width: 1280px) and (max-width: 1680px){
          left: 30px;
          top: 120px;
          font-size: 13px;
        }
              
        @media screen and (min-width: 1920px){
          left: 40px;
          top: 160px;
          font-size: 18px;
        }
      }

      .user {
        position: absolute;
        top: 160px;
        left: 20px;
        display: flex;

        @media (min-width: 1280px) and (max-width: 1680px){
          left: 30px;
          top: 240px;
        }
              
        @media screen and (min-width: 1920px){
          left: 40px;
          top: 320px;
        }
        img {
          width: 35px;
          height: 35px;

          @media (min-width: 1280px) and (max-width: 1680px){
            width: 43px;
            height: 43px;
          }
                
          @media screen and (min-width: 1920px){
            width: 70px;
            height: 70px;
          }
        }

        &-info {
          padding: 0 10px;
          font-size: 9px;
          color: #515151;
          display: flex;
          flex-direction: column;
          align-items: flex-start;

          @media (min-width: 1280px) and (max-width: 1680px){
            padding: 0 15px;
            font-size: 13px;
          }
                
          @media screen and (min-width: 1920px){
            padding: 0 20px;
            font-size: 18px;
          }
        }
      }
    }
  }
}
</style>